import type { Editor } from '@tiptap/core';

export interface IRichTextSelection {
	from: number;
	to: number;
}

export const applyRichTextLink = (
	editor: Editor,
	rawUrl: string,
	selection: IRichTextSelection = editor.state.selection
): boolean => {
	const trimmedUrl = rawUrl.trim();
	if (!trimmedUrl) return false;

	const href = /^(https?:|mailto:)/i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;
	const chain = editor.chain().focus().setTextSelection(selection);
	if (selection.from !== selection.to) {
		return chain.setLink({ href }).run();
	}

	return chain.insertContent({ type: 'text', text: href, marks: [{ type: 'link', attrs: { href } }] }).run();
};
